import React from 'react';

const Footer: React.FC = () => {
  return (
    <div
      style={{
        textAlign: 'center',
        paddingBlock: 16,
        lineHeight: '22px',
        color: 'var(--ant-color-text-description)',
      }}
    >
      <div>{`© ${new Date().getFullYear()} 西安知言云策科技有限公司. 保留所有权利.`}</div>
      <div>
        <a
          href="https://beian.miit.gov.cn/#/Integrated/index"
          target="_blank"
          rel="noreferrer"
          style={{ color: 'inherit' }}
        >
          陕ICP备2025075070号-1
        </a>
      </div>
    </div>
  );
};

export default Footer;
